import React from "react";
import ReactDOM from "react-dom/client";
import store from "./core/data/redux/store";
import { Provider } from "react-redux";
import { useSelector } from "react-redux";
import App from "./App";

//styles
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap-daterangepicker/daterangepicker.css";
import "bootstrap/dist/js/bootstrap.bundle.min.js";
import "primereact/calendar";
import "react-image-lightbox/style.css";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import "./assets/css/iconsax.css";
import "material-icons/iconfont/material-icons.css";
import "./assets/icons/fontawesome/css/fontawesome.min.css";
import "./assets/icons/fontawesome/css/all.min.css";
import "./assets/icons/feather/css/iconfont.css";
import "./assets/css/customstyleclient.css";

// Theme Wrapper Component
const ThemeWrapper = ({ children }) => {
  const dataTheme = useSelector((state) => state.themeSetting.dataTheme);

  React.useEffect(() => {
    const html = document.documentElement;

    html.classList.remove("light-mode", "dark-mode");

    if (dataTheme) {
      html.classList.add(dataTheme);
      html.setAttribute(
        "data-theme",
        dataTheme === "dark-mode" ? "dark" : "light"
      );
    } else {
      html.classList.add("light-mode");
      html.setAttribute("data-theme", "light");
    }
  }, [dataTheme]);

  return children;
};

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <Provider store={store}>
      <ThemeWrapper>
        <App />
      </ThemeWrapper>
    </Provider>
  </React.StrictMode>
);
